import React from "react"
import { useTranslation } from "react-i18next"

import { RoomOverlay, RoomOverlayModel } from "../room-overlay/RoomOverlay"

export type NewRoomOverlayViewModel = Omit<RoomOverlayModel, "id" | "headline">

export const NewRoomOverlayView = React.memo(
  (props: NewRoomOverlayViewModel) => {
    const { t } = useTranslation()

    return (
      <RoomOverlay
        id="new-room-overlay"
        headline={t("Room.Actions.Create")}
        prefix="room__create"
        submitButtonText={t("Room.Actions.Create")}
        {...props}
      />
    )
  }
)
